module.exports = __webpack_public_path__ + "static/media/IAP_WholeSale@3x.02720fd9.png";